export default function KpiCard({ label, value, previous, unit = '', icon = null, invertDelta = false }) {
  const hasPrev = previous != null && !Number.isNaN(Number(previous));
  const num = Number(value);
  const prevNum = Number(previous);
  let deltaPct = null;
  if (hasPrev && prevNum !== 0) {
    deltaPct = ((num - prevNum) / Math.abs(prevNum)) * 100;
  } else if (hasPrev && prevNum === 0 && num !== 0) {
    deltaPct = 100;
  }

  const positiveIsGood = !invertDelta;
  const deltaColor =
    deltaPct == null
      ? '#6B7280'
      : (deltaPct >= 0) === positiveIsGood
        ? '#059669'
        : '#DC2626';

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 flex flex-col justify-between min-h-[110px]">
      <div className="flex items-center justify-between text-xs uppercase tracking-wide text-gray-500">
        <span>{label}</span>
        {icon && <span className="text-lg">{icon}</span>}
      </div>
      <div className="mt-2 text-2xl font-semibold text-gray-900">
        {value == null ? '—' : `${formatNumber(value)}${unit}`}
      </div>
      {deltaPct != null && (
        <div className="text-xs mt-1" style={{ color: deltaColor }}>
          {deltaPct >= 0 ? '▲' : '▼'} {Math.abs(deltaPct).toFixed(1)}% vs prev
        </div>
      )}
    </div>
  );
}

function formatNumber(v) {
  const n = Number(v);
  if (Number.isNaN(n)) return v;
  if (Math.abs(n) >= 1000) return n.toLocaleString();
  if (!Number.isInteger(n)) return n.toFixed(2);
  return n.toString();
}
